import { EnterpriseRedirect } from '@/enterprise/Router';

const ExperienceRedirect = () => {
  return <EnterpriseRedirect />;
};

export default ExperienceRedirect;
